import { Divider, Layout, Menu } from 'antd'
import classNames from 'classnames'
import React from 'react'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import { Route, Switch } from 'react-router'
import { Link, withRouter } from 'react-router-dom'
import Redirect from 'react-router/Redirect'
import { withState } from 'recompose'
import { compose } from 'redux'

import AdminScreen from './components/AdminScreen'
import CategoriesList from './components/categories/CategoriesList'
import CategoryForm from './components/categories/CategoryForm'
import ChampionshipContainer from './components/championship/ChampionshipContainer'
import ChampionshipList from './components/championship/ChampionshipList'
import ChampionshipResultList from './components/championship/ChampionshipResultList'
import FlightsList from './components/flights/FlightsList'
import LiveFlights from './components/flights/LiveFlights'
import ListNavigation from './components/ListNavigation'
import Notifications from './components/Notifications'
import PlayerForm from './components/players/PlayerForm'
import PlayerList from './components/players/PlayerList'
import TeamForm from './components/teams/TeamForm'
import TeamList from './components/teams/TeamList'
import FlightsForm from './components/tournament/management/FlightsForm'
import TournamentCategoriesList from './components/tournament/management/TournamentCategoriesList'
import TournamentForm from './components/tournament/management/TournamentForm'
import TournamentPlayers from './components/tournament/management/TournamentPlayers'
import PlayerResults from './components/tournament/PlayerResults'
import ResultList from './components/tournament/ResultList'
import TeamResultsList from './components/tournament/TeamResultsList'
import TournamentContainer from './components/tournament/TournamentContainer'
import TournamentList from './components/tournament/TournamentList'
import TournamentStatistics from './components/tournament/TournamentStatistics'
import { playground } from './constants/playgrounds'
import { hasRole } from './helpers/auth'
import { ResultsDisplayMode } from './helpers/resultsDisplayMode'
import routes from './helpers/routes'
import { selectChampionshipInfo } from './redux/modules/championships'
import { setTenant } from './redux/modules/settings'
import { selectTournamentInfo } from './redux/modules/tournaments'

import './App.css'

class App extends React.Component<any, any> {
  componentWillReceiveProps(nextProps) {
    const { location, setPreviousLocation } = this.props
    if (location !== nextProps.location) {
      setPreviousLocation(location)
    }
  }

  componentDidMount() {
    this.props.onDidMount(this.props.match.params.tenant)
  }

  render() {
    const {
      match,
      firebase,
      auth,
      previousLocation,
      currentTournamentInfo,
      currentChampionshipInfo,
      profile,
    } = this.props
    const tenant = match.params.tenant
    const admin = hasRole('admin', tenant, profile)

    // tslint:disable jsx-no-lambda
    // TODO fix:tslint ^^^
    return (
      <Layout>
        <Notifications />
        {currentTournamentInfo.name && (
          <Layout.Header className="page-header">
            <Menu theme="dark" mode="horizontal" selectedKeys={[window.location.pathname]}>
              <Menu.Item
                className={classNames('header-tournament-menu-item', {
                  hidden: !currentTournamentInfo.public,
                })}>
                <Link
                  className="header-tournament-name"
                  to={routes.viewResults(
                    currentTournamentInfo.tenant,
                    currentTournamentInfo.tournamentId,
                  )}>
                  {currentTournamentInfo.name}
                </Link>
              </Menu.Item>
            </Menu>
          </Layout.Header>
        )}
        {currentChampionshipInfo.name && (
          <Layout.Header className="page-header">
            <Menu theme="dark" mode="horizontal" selectedKeys={[window.location.pathname]}>
              <Menu.Item>
                <Link
                  className="header-tournament-name"
                  to={routes.championshipResults(
                    currentChampionshipInfo.tenant,
                    currentChampionshipInfo.championshipId,
                  )}>
                  {currentChampionshipInfo.name}
                </Link>
              </Menu.Item>
            </Menu>
          </Layout.Header>
        )}
        <Layout.Content>
          <Switch>
            <Route
              exact
              path={`${match.url}/championships`}
              render={() => (
                <div className="ant-col-xl-10 ant-col-xl-offset-7 ant-col-lg-12 ant-col-lg-offset-6 and-col-md-20 ant-col-sm-24 container">
                  <ListNavigation
                    admin={admin}
                    match={match}
                    addItemUrl={`${match.url}/championships/new`}
                  />
                  <ChampionshipList admin={admin} tenant={tenant} matchUrl={match.url} />
                </div>
              )}
            />
            <Route
              exact
              path={`${match.url}/championships/:id/results`}
              render={(routeParams) => (
                // TODO remove container or use championship specific
                <ChampionshipContainer
                  className={'ant-col-22 ant-col-offset-1 ant-col-xs-24 ant-col-xs-offset-0'}
                  championshipId={routeParams.match.params.id}>
                  <Helmet>
                    <title>All Championship Results</title>
                  </Helmet>
                  <ChampionshipResultList
                    tenant={tenant}
                    championshipId={routeParams.match.params.id}
                  />
                </ChampionshipContainer>
              )}
            />
            <Route
              exact
              path={`${match.url}/tournaments`}
              render={() => (
                <div className="ant-col-xl-10 ant-col-xl-offset-7 ant-col-lg-12 ant-col-lg-offset-6 and-col-md-20 ant-col-sm-24 container">
                  <ListNavigation
                    admin={admin}
                    match={match}
                    addItemUrl={`${match.url}/tournaments/new`}
                  />
                  <TournamentList admin={admin} tenant={tenant} matchUrl={match.url} />
                </div>
              )}
            />
            <Route
              path={`${match.url}/tournaments/new`}
              render={() => (
                <TournamentContainer
                  className={'ant-col-lg-12 ant-col-lg-offset-6 ant-col-xs-24 ant-col-xs-offset-0'}>
                  <Helmet>
                    <title>Main Tournament Results</title>
                  </Helmet>
                  <TournamentForm tenant={tenant} previousLocation={previousLocation} />
                </TournamentContainer>
              )}
            />
            <Route
              exact
              path={`${match.url}/tournaments/:id/results`}
              render={(routeParams) => (
                <TournamentContainer
                  className={'ant-col-22 ant-col-offset-1 ant-col-xs-24 ant-col-xs-offset-0'}
                  tournamentId={routeParams.match.params.id}>
                  <Helmet>
                    <title>All Tournament Results</title>
                  </Helmet>
                  <ResultList
                    tenant={tenant}
                    tournamentId={routeParams.match.params.id}
                    resultsDisplayMode={ResultsDisplayMode.All}
                    playground={playground}
                  />
                </TournamentContainer>
              )}
            />
            <Route
              exact
              path={`${match.url}/tournaments/:id/teamResults`}
              render={(routeParams) => (
                <TournamentContainer
                  className={'ant-col-22 ant-col-offset-1 ant-col-xs-24 ant-col-xs-offset-0'}
                  tournamentId={routeParams.match.params.id}>
                  <Helmet>
                    <title>Team Tournament Results</title>
                  </Helmet>
                  <TeamResultsList
                    tenant={tenant}
                    tournamentId={routeParams.match.params.id}
                    playground={playground}
                  />
                </TournamentContainer>
              )}
            />
            <Route
              exact
              path={`${match.url}/tournaments/:id/results/main`}
              render={(routeParams) => (
                <TournamentContainer
                  className={'ant-col-22 ant-col-offset-1 ant-col-xs-24 ant-col-xs-offset-0'}
                  tournamentId={routeParams.match.params.id}>
                  <Helmet>
                    <title>Main Tournament Results</title>
                  </Helmet>
                  <ResultList
                    tenant={tenant}
                    tournamentId={routeParams.match.params.id}
                    resultsDisplayMode={ResultsDisplayMode.Main}
                    playground={playground}
                  />
                </TournamentContainer>
              )}
            />
            <Route
              exact
              path={`${match.url}/tournaments/:id/results/others`}
              render={(routeParams) => (
                <TournamentContainer
                  className={'ant-col-22 ant-col-offset-1 ant-col-xs-24 ant-col-xs-offset-0'}
                  tournamentId={routeParams.match.params.id}>
                  <Helmet>
                    <title>Other Tournament Results</title>
                  </Helmet>
                  <ResultList
                    tenant={tenant}
                    tournamentId={routeParams.match.params.id}
                    resultsDisplayMode={ResultsDisplayMode.Others}
                    playground={playground}
                  />
                </TournamentContainer>
              )}
            />
            <Route
              path={`${match.url}/tournaments/:id/edit`}
              render={(routeParams) => (
                <TournamentContainer
                  tournamentId={routeParams.match.params.id}
                  className={'ant-col-lg-12 ant-col-lg-offset-6 ant-col-xs-24 ant-col-xs-offset-0'}>
                  <Helmet>
                    <title>Edit Tournament</title>
                  </Helmet>
                  <TournamentForm
                    tenant={tenant}
                    tournamentId={routeParams.match.params.id}
                    previousLocation={previousLocation}
                  />
                </TournamentContainer>
              )}
            />
            <Route
              exact
              path={`${match.url}/tournaments/:id/categories/edit`}
              render={(routeParams) => (
                <TournamentContainer
                  className="container ant-col-24 "
                  tournamentId={routeParams.match.params.id}>
                  <Helmet>
                    <title>Tournament Categories</title>
                  </Helmet>
                  <TournamentCategoriesList
                    tenant={tenant}
                    tournamentId={routeParams.match.params.id}
                  />
                </TournamentContainer>
              )}
            />
            <Route
              path={`${match.url}/tournaments/:id/categories/new`}
              render={(routeParams) => (
                <TournamentContainer
                  className="container ant-col-24 "
                  tournamentId={routeParams.match.params.id}>
                  <Helmet>
                    <title>New Category</title>
                  </Helmet>
                  <TournamentCategoriesList
                    tenant={tenant}
                    tournamentId={routeParams.match.params.id}
                    newCategory
                  />
                </TournamentContainer>
              )}
            />
            <Route
              exact
              path={`${match.url}/tournaments/:id/categories/:categoryId/edit`}
              render={(routeParams) => (
                <TournamentContainer
                  className="container ant-col-24 "
                  tournamentId={routeParams.match.params.id}>
                  <Helmet>
                    <title>Edit Category</title>
                  </Helmet>
                  <TournamentCategoriesList
                    tenant={tenant}
                    tournamentId={routeParams.match.params.id}
                    categoryId={routeParams.match.params.categoryId}
                  />
                </TournamentContainer>
              )}
            />
            <Route
              exact
              path={`${match.url}/tournaments/:id/flights`}
              render={(routeParams) => (
                <TournamentContainer
                  tournamentId={routeParams.match.params.id}
                  className={
                    'ant-col-22 ant-col-lg-8 ant-col-lg-offset-8 ant-col-xs-24 ant-col-xs-offset-0'
                  }>
                  <Helmet>
                    <title>Tournament Flights</title>
                  </Helmet>
                  <FlightsList
                    tenant={tenant}
                    playground={playground}
                    tournamentId={routeParams.match.params.id}
                  />
                </TournamentContainer>
              )}
            />
            <Route
              path={`${match.url}/tournaments/:id/flights/live/:round`}
              render={(routeParams) => (
                <TournamentContainer tournamentId={routeParams.match.params.id}>
                  <Helmet>
                    <title>Live Tournament Flights</title>
                  </Helmet>
                  <LiveFlights
                    tenant={tenant}
                    tournamentId={routeParams.match.params.id}
                    round={Number(routeParams.match.params.round)}
                    playground={playground}
                  />
                </TournamentContainer>
              )}
            />
            <Route
              path={`${match.url}/tournaments/:id/flights/edit`}
              render={(routeParams) => (
                <TournamentContainer
                  className="container ant-col-24"
                  tournamentId={routeParams.match.params.id}>
                  <Helmet>
                    <title>Edit Tournament Flights</title>
                  </Helmet>
                  <FlightsForm
                    tenant={tenant}
                    playground={playground}
                    tournamentId={routeParams.match.params.id}
                  />
                </TournamentContainer>
              )}
            />
            <Route
              path={`${match.url}/tournaments/:id/players/:playerId/results`}
              render={(routeParams) => (
                <TournamentContainer
                  className="ant-col-lg-10 ant-col-lg-offset-7 ant-col-sm-24 container"
                  tournamentId={routeParams.match.params.id}>
                  <Helmet>
                    <title>Tournament Results</title>
                  </Helmet>
                  <PlayerResults
                    tenant={tenant}
                    tournamentId={routeParams.match.params.id}
                    playerId={routeParams.match.params.playerId}
                    playground={playground}
                  />
                </TournamentContainer>
              )}
            />
            <Route
              path={`${match.url}/tournaments/:id/players/edit`}
              render={(routeParams) => (
                <TournamentContainer
                  className="container ant-col-24 "
                  tournamentId={routeParams.match.params.id}>
                  <Helmet>
                    <title>Edit Tournament Players</title>
                  </Helmet>
                  <TournamentPlayers tenant={tenant} tournamentId={routeParams.match.params.id} />
                </TournamentContainer>
              )}
            />
            <Route
              exact
              path={`${match.url}/tournaments/:id/statistics`}
              render={(routeParams) => (
                <TournamentContainer
                  className="ant-col-lg-22 ant-col-lg-offset-1 ant-col-sm-24 ant-col-xs-offset-0 container"
                  tournamentId={routeParams.match.params.id}>
                  <Helmet>
                    <title>Player Statistcs</title>
                  </Helmet>
                  <TournamentStatistics
                    tenant={tenant}
                    tournamentId={routeParams.match.params.id}
                  />
                </TournamentContainer>
              )}
            />
            <Route
              exact
              path={`${match.url}/players`}
              render={() => (
                <div className=" ant-col-lg-8 ant-col-lg-offset-8 ant-col-sm-24 container">
                  {admin && (
                    <ListNavigation
                      admin={admin}
                      match={match}
                      addItemUrl={`${match.url}/players/new`}
                    />
                  )}
                  <Helmet>
                    <title>Players</title>
                  </Helmet>
                  <PlayerList matchUrl={`${match.url}/players/new`} tenant={tenant} />
                </div>
              )}
            />
            <Route
              path={`${match.url}/players/new`}
              render={() => (
                <React.Fragment>
                  <Helmet>
                    <title>Add Player</title>
                  </Helmet>
                  <PlayerForm tenant={tenant} previousLocation={previousLocation} />
                </React.Fragment>
              )}
            />
            <Route
              path={`${match.url}/players/:id/edit`}
              render={(routeParams) => (
                <React.Fragment>
                  <Helmet>
                    <title>Edit Player</title>
                  </Helmet>
                  <PlayerForm
                    tenant={tenant}
                    playerId={routeParams.match.params.id}
                    previousLocation={previousLocation}
                  />
                </React.Fragment>
              )}
            />
            <Route
              exact
              path={`${match.url}/categories`}
              render={() => (
                <div className=" ant-col-lg-8 ant-col-lg-offset-8 ant-col-sm-24 container">
                  {admin && (
                    <ListNavigation
                      admin={admin}
                      match={match}
                      addItemUrl={`${match.url}/categories/new`}
                    />
                  )}
                  <Helmet>
                    <title>Categories</title>
                  </Helmet>
                  <CategoriesList tenant={tenant} />
                </div>
              )}
            />
            <Route
              path={`${match.url}/categories/new`}
              render={() => (
                <React.Fragment>
                  <Helmet>
                    <title>Add Category</title>
                  </Helmet>
                  <CategoryForm tenant={tenant} previousLocation={previousLocation} />
                </React.Fragment>
              )}
            />
            <Route
              path={`${match.url}/categories/:id/edit`}
              render={(routeParams) => (
                <React.Fragment>
                  <Helmet>
                    <title>Edit Category</title>
                  </Helmet>
                  <CategoryForm
                    tenant={tenant}
                    categoryId={routeParams.match.params.id}
                    previousLocation={previousLocation}
                  />
                </React.Fragment>
              )}
            />
            <Route
              exact
              path={`${match.url}/teams`}
              render={() => (
                <div className=" ant-col-lg-8 ant-col-lg-offset-8 ant-col-sm-24 container">
                  {admin && (
                    <ListNavigation
                      admin={admin}
                      match={match}
                      addItemUrl={`${match.url}/teams/new`}
                    />
                  )}
                  <Helmet>
                    <title>Teams</title>
                  </Helmet>
                  <TeamList tenant={tenant} />
                </div>
              )}
            />
            <Route
              path={`${match.url}/teams/new`}
              render={() => (
                <React.Fragment>
                  <Helmet>
                    <title>Add Team</title>
                  </Helmet>
                  <TeamForm tenant={tenant} previousLocation={previousLocation} />
                </React.Fragment>
              )}
            />
            <Route
              path={`${match.url}/teams/:id/edit`}
              render={(routeParams) => (
                <React.Fragment>
                  <Helmet>
                    <title>Edit Team</title>
                  </Helmet>
                  <TeamForm
                    tenant={tenant}
                    teamId={routeParams.match.params.id}
                    previousLocation={previousLocation}
                  />
                </React.Fragment>
              )}
            />
            <Route
              path={`/admin`}
              render={(routeParams) => (
                <AdminScreen
                  auth={auth}
                  onLogin={firebase.login}
                  onLogout={firebase.logout}
                  tenant={tenant}
                />
              )}
            />
            <Redirect from={`${match.url}/`} to={`${match.url}/tournaments`} />
          </Switch>
        </Layout.Content>
        <Layout.Footer>
          <div>© {new Date().getFullYear()} Adventure Golf Horní Bezděkov</div>
          <div>
            Created by <a href="https://purebrew.tech">purebrew</a>
            <Divider type="vertical" />
            <a href="mailto:info@purebrew.tech">info@purebrew.tech</a>
          </div>
          {process.env.REACT_APP_BUILD_SHA && <div>revision {process.env.REACT_APP_BUILD_SHA}</div>}
        </Layout.Footer>
      </Layout>
    )
    // tslint:enable jsx-no-lambda
  }
}

export default compose<any>(
  firebaseConnect(), // withFirebase can also be used
  withState('previousLocation', 'setPreviousLocation', undefined),
  connect(
    ({ firebase: { auth, profile }, ...rest }: FIXME) => ({
      auth,
      profile,
      currentTournamentInfo: selectTournamentInfo(rest),
      currentChampionshipInfo: selectChampionshipInfo(rest),
    }),
    { onDidMount: setTenant },
  ),
  withRouter,
)(App)



// WEBPACK FOOTER //
// ./src/App.tsx